module.exports = __webpack_public_path__ + "img/Albania.dda1314a.gif";